// this file is generated by update_shopify_store_data.py at 2026-11-03 20:19:01.186048
var courses = [
    {
        "course_id": "3590526F-4EF4-EF11-9992-005056A7DAD4",
        "course_version": 2,
        "name": "The Science of Aging Well: Insights for Healthcare Professionals",
        "course_type": 1,
        "author_information": "Cathy Maxwell, PhD, RN, FAAN, FNAP",
        "description": "Aging is the single most risk factor for chronic disease, functional decline, frailty, morbidity and mortality. Aging, as a risk factor, far outweighs genetic and environmental influences, yet biological mechanisms that lead to avoidable outcomes are poorly understood by both clinicians and the public-at-large. Today\u2019s health care clinicians need to be equipped with a basic understanding of biological principles of healthy aging so that that they can translate them to the public. This course promotes a paradigm shift towards geroscience, the intersection of basic aging biology, chronic disease and health. The course will provide front line clinicians with knowledge and skills to assist patients and communities with proactive planning for health-related quality of life and longevity. Learners will gain an understanding of the hallmarks of aging, with particular emphasis on mitochondrial function. The course will also provide a roadmap for assisting patients with goal setting in targeted areas of prevention that are essential for healthy aging.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<li>Describe the difference between chronological aging and biological aging\r\n</li>\r\n<li>Apply knowledge about biological aging and frailty screenings to application of screening processes for various clinical settings\r\n</li>\r\n<li>Explain the role of mitochondria as an aging driver and topic of focus for healthy aging\r\n</li>\r\n<li>Explain preventive measures for proactive planning for healthy aging</li>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "D0B2F3ED-33D4-E511-93E1-005056B12CFE",
                "course_category_name": "Psychosocial Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DCFCDA08-33D4-E511-93E1-005056B12CFE",
                "course_category_name": "Care Coordination",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5304C9CB-6EAB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EBDFBCD4-F8D1-F011-99C2-005056A7C6AF",
                "course_category_name": "Vanderbilt University School of Nursing - Prevention and Whole Person Care (COURSES)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A2B7FF67-CEC9-E511-82AF-005056B150D3",
                "course_category_name": "End of Life Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8F6B91A1-C8B8-F011-999F-005056A78EAA",
                "course_category_name": "Vanderbilt University School of Nursing: The Science of Aging Well: Insights for Healthcare Professionals",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D6EC53E-1F26-E711-9EDE-005056B14F90",
                "course_category_name": "Geriatric Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E64A7C75-8EC5-E811-AEE3-005056B11CD6",
                "course_category_name": "Population Health Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31589936-71AB-F011-99AA-005056A77B46",
                "course_category_name": "Vanderbilt University School of Nursing - Individual Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "62F4CAD0-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nutrition",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6FCCD559-0EBF-E211-97A9-001517135213",
                "course_category_name": "Cardiac Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3F30DEBA-C7B8-F011-999F-005056A78EAA",
                "course_category_name": "Vanderbilt University School of Nursing: The Science of Aging Well: Insights for Healthcare Professionals",
                "is_system_course_category": null
            },
            {
                "course_category_id": "00A65374-1B26-E711-9EDE-005056B14F90",
                "course_category_name": "Alternative Medicine",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "Vanderbilt University School of Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation.\r\n<br />\r\n<br />\r\nThis activity will award 2.5 contact hours to participants who complete all sections and pass the assessment with a score of 90% or greater.  No partial credit will be given.\r\n<br />\r\n<br />\r\nThere are no financial relationships to disclose.",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 2.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];